const importAll = r => {
  let images = {};
  r.keys().forEach(key => {
    const filename = key.replace("./", "");
    const mod = r(key);
    images[filename] = mod.default || mod;
  });
  return images;
};

export const loadPaymentMethodImage = filename =>
  importAll(
    require.context(
      "../assets/images/payment-methods/",
      false,
      /\.(png|jpe?g|svg)$/
    )
  )[filename];

export const loadBanksImage = filename =>
  importAll(
    require.context(
      "../assets/images/banks/",
      false,
      /\.(png|jpe?g|svg)$/
    )
  )[filename];
